import { ISusuario } from '../../types/usuario/Usuario';
import { ISusuarioList, UsuarioList } from '../../types/usuario/UsuarioList';
import { ISNoticiaTipo, NoticiaTipo } from './NoticiaTipo';

export const ISnoticia: Noticia = {
  id: '',
  titulo: '',
  subtitulo: '',
  resumo: '',
  corpo: '',
  is_publica: false,
  imagem: '',
  usuario: ISusuarioList,
  tipo: ISNoticiaTipo,
  dataHoraAtualizacao: '',
  dataHoraLiberacao: '',
  dataHoraCriacao: '',
  capa:false
};

export interface Noticia {
  id: string;
  titulo: string;
  subtitulo: string;
  resumo: string;
  corpo: string;
  is_publica: boolean;
  imagem: string;
  tipo: NoticiaTipo;
  usuario: UsuarioList;
  dataHoraAtualizacao: string;
  dataHoraLiberacao: string;
  dataHoraCriacao: string;
  capa: boolean;
}
export interface NoticiaDTO {
  id: string;
  titulo: string;
  subtitulo: string;
  resumo: string;
  corpo: string;
  imagem: string;
  tipoID: string;
  dataHoraLiberacao: string;
  capa:boolean;
}

export const ISnoticiaDTO: NoticiaDTO = {
  id: '',
  titulo: '',
  subtitulo: '',
  resumo: '',
  corpo: '',
  imagem: '',
  tipoID: '',
  dataHoraLiberacao: '',
  capa:false,
};

export const ISnoticiaList: NoticiaList = {
  id: '',
  titulo: '',
  imagem: '',
  resumo: '',
  usuario: ISusuarioList,
  dataHoraAtualizacao: '',
  dataHoraLiberacao: '',
  dataHoraCriacao: ''
};

export interface NoticiaList {
  id: string;
  titulo?: string;
  imagem?: string;
  resumo?: string;
  usuario?: UsuarioList;
  dataHoraAtualizacao?: string;
  dataHoraLiberacao?: string;
  dataHoraCriacao?: string;
}
export interface NoticiaListPublicResponse {
  results: NoticiaList[];
  noticiaCardForm: NoticiaList[];
  count: number;
  next: string | null;
  previous: string | null;
}
